import { render } from "./DashboardSuccessStoryCard.vue?vue&type=template&id=15bee21e"
import script from "./DashboardSuccessStoryCard.vue?vue&type=script&lang=js"
export * from "./DashboardSuccessStoryCard.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__